// @mui
import { useCallback } from 'react';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import { useDoubleClick } from 'src/hooks/use-double-click';
// hooks
import { useCopyToClipboard } from 'src/hooks/use-copy-to-clipboard';

import metadata from 'src/metadata.json';

import { toast } from 'src/components/snackbar';
import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export function NavUpgrade() {
  const { copy } = useCopyToClipboard();

  const onCopy = useCallback(
    (text) => {
      if (text) {
        toast.success('Copied!');
        copy(text);
      }
    },
    [copy]
  );

  const handleClick = useDoubleClick({
    doubleClick: () =>
      onCopy(
        `Version ${metadata.buildMajor}.${metadata.buildMinor}.${metadata.buildRevision} ${metadata.buildTag}`
      ),
  });

  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center">
        <Button
          sx={{ borderColor: 'purple', color: 'purple' }}
          variant="outlined"
          startIcon={<Iconify icon="arcticons:verge" />}
          onClick={handleClick}
        >
          {` ${metadata.buildMajor}.${metadata.buildMinor}.${metadata.buildRevision} ${metadata.buildTag}`}
        </Button>
      </Stack>
    </Stack>
  );
}
